export default {
  xeroReport: undefined,
  xeroReports: [],
};
